import SplitJunction from './SplitJunction';

export default SplitJunction;
